import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  appWrapperBox: {
    padding: '12px 6px 0 6px',
    textAlign: 'center',
    border: 'solid 1px transparent',
    '&:hover': {
      border: 'solid 1px #e0e0e0',
      borderRadius: 2,
    },
  },
}));

function AppStoreIcon({ linkToApp, appName, appImage, onClick }) {
  const { appWrapperBox } = useStyles();

  return (
    <Link href={linkToApp || ''} underline="none" color="secondary" onClick={onClick}>
      <div className={appWrapperBox}>
        {appImage}
        <Typography variant="caption">{appName}</Typography>
      </div>
    </Link>
  );
}

AppStoreIcon.propTypes = {
  linkToApp: PropTypes.string,
  appName: PropTypes.string,
  appImage: PropTypes.element,
  onClick: PropTypes.func,
};

export default AppStoreIcon;
